import React from "react";

const HoTrafficLight = ({ size = 24, color = "currentColor", ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    role="img"
    aria-label="Traffic light"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      {/* Housing */}
      <rect x="7" y="2.5" width="10" height="16" rx="2" />
      {/* Lights */}
      <circle cx="12" cy="7" r="1.5" />
      <circle cx="12" cy="11" r="1.5" />
      <circle cx="12" cy="15" r="1.5" />
      {/* Pole */}
      <path d="M12 18.5V22" />
    </g>
  </svg>
);

export default HoTrafficLight;
